import axios from 'axios'
import config from '../../config'
import {Loading} from 'element-ui'

let loadingInstance = null;

const request = axios.create({
  onDownloadProgress:(progressEvent) => {
    if(progressEvent.event.lengthComputable){
      const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
      // console.log(`下载进度: ${percent}%`);
      // 更新 UI 进度显示
      updateProgress(percent, progressEvent.loaded, progressEvent.total);
    }
  },
  baseURL: config.baseUrl,
})

request.interceptors.request.use(function (config) {
  if (config.loading) {
    loadingInstance = Loading.service({
      fullscreen: true,
      lock: true,
    })
  }
  return config
}, function (error) {
  closeLoading();
  console.error('request error', error)
  return Promise.reject(error)
})

request.interceptors.response.use(function (response) {
  closeLoading();
  if (response.status === 200) {
    return response.data
  }
}, function (error) {
  closeLoading();
  console.error('response error', error)
  return Promise.reject(error)
})

function closeLoading() {
  if (loadingInstance) {
    loadingInstance.close();
  }
}

// 更新进度显示的函数
function updateProgress(percent, loaded, total) {
  // 这里可以更新您的 UI 组件
  // document.getElementById('progress-bar').value = percent;
  // document.getElementById('progress-text').innerText = `${percent}%`;

  // 计算下载速度
  if (window.lastLoadedTime) {
    const timeDiff = (Date.now() - window.lastLoadedTime) / 1000; // 秒
    const loadedDiff = loaded - window.lastLoaded;
    const speed = (loadedDiff / 1024 / timeDiff).toFixed(2); // KB/s
    if(speed > 0 ){
      console.log(`下载速度: ${speed} KB/s`);
    }
  }

  window.lastLoaded = loaded;
  window.lastLoadedTime = Date.now();
}

export default request
